import { api } from '../utils/apiHelpers';
import { EmailVerificationRequestDto, UserDto } from './dtos/user';
import { dtoToEmailVerificationRequest, dtoToUser } from './transformers/users';
import { sagwClient } from './clients';

export const fetchUserDetails = () => api.get<UserDto>('/v1/users/me').then(dtoToUser);

export const logout = () => api.post('/v1/users/logout');

export const updateUserEmail = async (email: string) =>
  sagwClient
    .patch<EmailVerificationRequestDto>('/identity/v10/userInfo/email', { email })
    .then(dtoToEmailVerificationRequest);
